import React from "react";
import Icon from "./Icon";

export const CloseCircleIcon = () => (
  <Icon>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.59 7.98986L12 10.59L9.48169 7.98986C9.09169 7.59986 8.46169 7.59986 8.07169 7.98986C7.68169 8.37986 7.68169 9.00986 8.07169 9.39986L10.59 12L8.07169 14.59C7.68169 14.98 7.68169 15.61 8.07169 16C8.46169 16.39 9.09169 16.39 9.48169 16L12 13.41L14.59 16C14.98 16.39 15.61 16.39 16 16C16.39 15.61 16.39 14.98 16 14.59L13.41 12L16 9.39986C16.39 9.00986 16.39 8.37986 16 7.98986C15.61 7.60986 14.97 7.60986 14.59 7.98986ZM12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="#232323"/>
  </Icon>
);
